import URLS from "./navigation";

const menuLinks = [
  {
    url: URLS.SETTINGS.EDIT,
    name: 'Edit Profile'
  },
  {
    url: URLS.SETTINGS.SETTINGS,
    name: 'Account Settings'
  }
];

export default menuLinks;
